export default __webpack_public_path__ + "static/media/video.76bae9eb.mp4";